<ng-container
  *ngIf="fGroup && fGroup.controls._documentItemTaxes"
  [formGroup]="fGroup"
>
  <ng-container formArrayName="_documentItemTaxes">
    <div
      *ngFor="let itemTax of fArray.controls; let i = index"
      [formGroupName]="i"
    >
      <app-document-item-tax
        [class]="classTax"
        [fGroup]="fArray.controls[i]"
      ></app-document-item-tax>
    </div>
  </ng-container>
</ng-container>
